import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchThingDetails } from "features/thing/thingThunk";
import { getGroupVehicleDetails, editGroupVehiclesDetails } from "config/apis";
import { fetchGroups } from "features/management/vehicleGroup/groupsThunks";

const EditCard = ({ open, onClose, groupId }) => {
  const dispatch = useDispatch();
  const things = useSelector((state) => state.things.things || []);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [apiSelected, setApiSelected] = useState([]); // 🔥 NEW STATE

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  useEffect(() => {
    if (open && groupId) {
      fetchVehicles(groupId);
    } else {
      setSelected([]);
      setApiSelected([]);
    }
  }, [open, groupId]);

  // 🔥 IMPORTANT: Jab things load ho jaye tab selected set karo
  useEffect(() => {
    if (things.length > 0 && apiSelected.length > 0) {
      const normalized = apiSelected.map((id) => String(id));
      setSelected(normalized);
    }
  }, [things, apiSelected]);

  const fetchVehicles = async (groupId) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await fetch(getGroupVehicleDetails, {
        method: "POST",
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ groupId }),
      });

      const data = await res.json();

      if (Array.isArray(data)) {
        setApiSelected(data);
      } else if (Array.isArray(data?.result)) {
        setApiSelected(data.result);
      }
    } catch (err) {
      console.error("Error fetching vehicles:", err);
    }
    setLoading(false);
  };

  const handleToggle = (vehicleNo) => {
    const id = String(vehicleNo);

    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((v) => v !== id)
        : [...prev, id]
    );
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");
    try {
      const payload = {
        groupId,
        thingIds: selected.map((id) => ({ thingId: id })),
      };

      const res = await fetch(editGroupVehiclesDetails, {
        method: "POST",
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        dispatch(fetchGroups());
        onClose();
      }
    } catch (err) {
      console.error("Error updating vehicles:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Assign Vehicles to Group</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table>
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell>Vehicle No</TableCell>
                <TableCell>Nick Name</TableCell>
                <TableCell>Vehicle Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {things.map((v) => (
                <TableRow key={v.thingId}>
                  <TableCell>
                    <Checkbox
                      checked={selected.includes(String(v.thingId))}
                      onChange={() => handleToggle(v.thingId)}
                    />
                    {v.thingId}
                  </TableCell>
                  <TableCell>{v.nickName}</TableCell>
                  <TableCell>{v.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        {!loading && things.length === 0 && (
          <Typography sx={{ mt: 2 }}>No vehicles found.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        <Button onClick={handleUpdate} variant="contained" color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditCard.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groupId: PropTypes.number,
};

export default EditCard;
